const ANON_SESSION_KEY = 'bquest_anon_session_id';

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Returns the stable pre-login UUID used for analytics and signup attribution. */
export const ensureAnonSessionId = (): string => {
  try {
    const existing = localStorage.getItem(ANON_SESSION_KEY);
    if (existing && UUID_PATTERN.test(existing)) return existing;
    const fresh = crypto.randomUUID();
    localStorage.setItem(ANON_SESSION_KEY, fresh);
    return fresh;
  } catch {
    return crypto.randomUUID();
  }
};
